module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_3_3_52.3be1bca5.png";